// @flow

import React from 'react';
import logoSrc from './logo.png';

const ParkChicagoLogo = () => (
  <img src={logoSrc} width="387" height="66" alt="ParkChicago Logo" />
);

export default ParkChicagoLogo;



// WEBPACK FOOTER //
// ./src/assets/park-chicago-logo.js